// @flow
import { StandardResourceSection } from '../StandardResourceSection';
import { ImageList } from './ImageList';
import { ImageView } from './ImageView';

import type { Location, Match } from 'react-router-dom';

export const ImageSection = ({ match }: { location: Location, match: Match }): React$Node => (
    <StandardResourceSection match={match} list={ImageList} view={ImageView} />
)